module.exports = __webpack_public_path__ + "static/media/work7.e131d5d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/work7.png
// module id = 88
// module chunks = 0